let globalIsUsingStaticRendering = false

export function enableStaticRendering(enable: boolean) {
    globalIsUsingStaticRendering = enable
}

export function isUsingStaticRendering(): boolean {
    return globalIsUsingStaticRendering
}
